var $ = require('jquery');

module.exports = {
	options: function (className) {
		return {
			fixed: true,
			initialHeight: 300,
			initialWidth: 500,
			close: "<span>Close</span>",
			current: '',
			maxHeight: '90%',
			maxWidth: '90%',
			opacity: .30,
			scalePhotos: true,
			speed: 450,
			transition: 'elastic',
			className: className
		}
	},
	load: function(href){
		var fullHtml = '';
		$.ajax({
			url: href,
			success: function(data) {
				var $data = $('#lightboxContent', data);
				fullHtml = '<div id="' + $data.attr('id') + '" class="' + $data.attr('class') + '">';
				$data.each(function() {
					var html = $(this).html();
					if (typeof html === 'string') {
						fullHtml += html;
					}
				});
				var tempDom = new DOMParser().parseFromString(data, "text/html");
				var ajaxBehaviors = tempDom.querySelectorAll(".recaptcha-v3-script");
				for (var i = 0; i < ajaxBehaviors.length; ++i) {
					var html = ajaxBehaviors.item(i).outerHTML;
					if (typeof html === 'string') {
						fullHtml += html;
					}
				}
				fullHtml = fullHtml + '</div>'
			},
			async: false
		});
		return fullHtml;
	}
}